import React from 'react';
import styled from '@emotion/styled';
import { PageTitle } from 'ui/components/elements/PageTitle/PageTitle';
import { SnackBar } from 'ui/components/elements/SnackBar/SnackBar';
import { useSupporterBuyerEdit } from './useSupporterBuyerEdit';
import { mqUser } from 'utils/responsive';
import { BuyerEditForm } from 'ui/components/buyer/patterns/BuyerEditForm/BuyerEditForm';

const BgWrapper = styled.div`
    padding: 18px 50px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    text-align: left;
    background-color: #f8f9fd;
    height: auto;
    min-height: calc(100vh - var(--height-pc-header));

    ${mqUser('SP')} {
        padding: 18px 15px;
    }
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 40px;
`;

const ErrorMessage = styled.div`
    background-color: #fee;
    color: #c33;
    padding: 16px;
    border-radius: 4px;
    margin: 20px 0;
    text-align: center;
`;

const LoadingMessage = styled.div`
    text-align: center;
    padding: 40px;
    color: #666;
    font-size: var(--font-medium);
`;

/**
 * サポーター用買い手企業プロフィール編集ページ
 */
export const SupporterBuyerEdit: React.FC = () => {
    const {
        control,
        loading,
        errors,
        areaChoices,
        employeeChoices,
        revenueChoices,
        industryChoices,
        employeeLowerChoices,
        employeeUpperChoices,
        netAssetsLevelLowerChoices,
        netAssetsLevelUpperChoices,
        purchaseAmountLowerChoices,
        purchaseAmountUpperChoices,
        revenueScaleLowerChoices,
        revenueScaleUpperChoices,
        profitLevelLowerChoices,
        profitLevelUpperChoices,
        hasAcquisitionExperienceChoices,
        editing,
        user,
        snackBarMessage,
        showSnackbar,
        setEditing,
        setShowSnackbar,
        submit,
        setValue,
        watch,
        onCompanySelect,
        error,
        buyerType,
    } = useSupporterBuyerEdit();

    if (loading && !user) {
        return (
            <BgWrapper>
                <Wrapper>
                    <PageTitle title="買い手企業プロフィール編集" />
                    <LoadingMessage>読み込み中...</LoadingMessage>
                </Wrapper>
            </BgWrapper>
        );
    }

    if (error) {
        return (
            <BgWrapper>
                <Wrapper>
                    <PageTitle title="買い手企業プロフィール編集" />
                    <ErrorMessage>{error}</ErrorMessage>
                </Wrapper>
            </BgWrapper>
        );
    }

    if (!user || buyerType !== 'buyer') {
        return (
            <BgWrapper>
                <Wrapper>
                    <PageTitle title="買い手企業プロフィール編集" />
                    <ErrorMessage>
                        {buyerType !== 'buyer' ? '買い手企業のみ編集可能です' : '買い手企業情報が見つかりません'}
                    </ErrorMessage>
                </Wrapper>
            </BgWrapper>
        );
    }

    return (
        <BgWrapper>
            <Wrapper>
                <SnackBar message={snackBarMessage} open={showSnackbar} setOpen={setShowSnackbar} />
                <div>
                    <PageTitle title="買い手企業プロフィール編集" />
                </div>
                <BuyerEditForm
                    user={user}
                    control={control}
                    loading={loading}
                    errors={errors}
                    areaChoices={areaChoices}
                    employeeChoices={employeeChoices}
                    revenueChoices={revenueChoices}
                    industryChoices={industryChoices}
                    employeeLowerChoices={employeeLowerChoices}
                    employeeUpperChoices={employeeUpperChoices}
                    revenueScaleLowerChoices={revenueScaleLowerChoices}
                    revenueScaleUpperChoices={revenueScaleUpperChoices}
                    profitLevelLowerChoices={profitLevelLowerChoices}
                    profitLevelUpperChoices={profitLevelUpperChoices}
                    netAssetsLevelLowerChoices={netAssetsLevelLowerChoices}
                    netAssetsLevelUpperChoices={netAssetsLevelUpperChoices}
                    purchaseAmountLowerChoices={purchaseAmountLowerChoices}
                    purchaseAmountUpperChoices={purchaseAmountUpperChoices}
                    hasAcquisitionExperienceChoices={hasAcquisitionExperienceChoices}
                    submit={submit}
                    setValue={setValue}
                    watch={watch}
                    onCompanySelect={onCompanySelect}
                    showSnackbar={showSnackbar}
                    setShowSnackbar={setShowSnackbar}
                    editing={editing}
                    setEditing={setEditing}
                />
            </Wrapper>
        </BgWrapper>
    );
};
